var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{staticClass:"rounded-xl",attrs:{"placeholder":(_vm.quantityOfNodeOutputs + " outputs"),"single-line":"","filled":"","rounded":"","dense":"","hide-details":"","disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }